import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// 컨트롤러 자동 로딩 지원 - importmap을 통해 필요 시 로드
application.router.modulesByIdentifier = new Map()

// 개발 환경에서 컨트롤러 로딩 로그
if (application.debug) {
  const originalRegister = application.register
  application.register = function(identifier, constructor) {
    console.log(`Stimulus: Registering controller "${identifier}"`)
    return originalRegister.call(this, identifier, constructor)
  }
}

export { application }
